//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.PostControl.js";
import "../no/ugmath.js";
let d=[[[0,"CurrentStep",0,0],[0,"Delay",1,0],[0,"Mode",1,0],[0,"NumberSteps",0,0]],[[[],"Play",{},0,0],[[],"PlayBackward",{},0,0],[[],"Pause",{},0,0],[[],"Stop",{},0,0],[["step"],"StepTo",{},1,0],[[],"StepForward",{},0,0],[[],"StepBackward",{},0,0],[[],"StepFirst",{},0,0],[[],"StepLast",{},0,0],[[],"ReloadResults",{},0,0],[[],"StepToDesignPosition",{},0,0],[[],"StepToAssemblyPosition",{},0,0],[[],"Finish",{},0,0],[["linkTag","inputStep"],"GetLinkTransformation",{R_:{transformationMatrix:''}},2,0],[["solutionTags"],"AddSolutions",{},1,0]],[]];
SPLM.Motion.AnimationControl = class extends SPLM.Motion.PostControl{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.AnimationControl";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;